import { Avatar, Chip, Fab, IconButton, ListItem } from "@mui/material";
import { Box } from "@mui/system";
import ScrollContainer from "react-indiana-drag-scroll";
import PageRoutes from "../Config/PageRoutes";
import classes from '../Style/CommoditiesMenu.scss'
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useRef } from "react";
import bovineLiverImg from '../Assets/bovine-liver.png';
import carrotsImg from '../Assets/carrots.png';
import cauliflowersImg from '../Assets/cauliflowers.png';
import driedBeansImg from '../Assets/dried-beans.png';
import kiwiFruitsImg from '../Assets/kiwi-fruits.png';
import onionsImg from '../Assets/onions.png';
import orangesImg from '../Assets/oranges.png';
import pearsImg from '../Assets/pears.png';
import potatoesImg from '../Assets/potatoes.png';
import poultryFatImg from '../Assets/poultry-fat.png';
import riceImg from '../Assets/rice.png';
import ryeImg from '../Assets/rye.png';

import bovineLiverImgW from '../Assets/bovine-liver_w.png';
import carrotsImgW from '../Assets/carrots_w.png';
import cauliflowersImgW from '../Assets/cauliflowers_w.png';
import driedBeansImgW from '../Assets/dried-beans_w.png';
import kiwiFruitsImgW from '../Assets/kiwi-fruits_w.png';
import onionsImgW from '../Assets/onions_w.png';
import orangesImgW from '../Assets/oranges_w.png';
import pearsImgW from '../Assets/pears_w.png';
import potatoesImgW from '../Assets/potatoes_w.png';
import poultryFatImgW from '../Assets/poultry-fat_w.png';
import riceImgW from '../Assets/rice_w.png';
import ryeImgW from '../Assets/rye_w.png';
const CommoditiesMenu = () => {

    const container = useRef(null);

    const commodities = [

        { name: 'Carrots', icon: carrotsImg, activeIcon: carrotsImgW },
        { name: 'Cauliflowers', icon: cauliflowersImg, activeIcon: cauliflowersImgW },
        { name: 'Kiwi fruits', icon: kiwiFruitsImg, activeIcon: kiwiFruitsImgW },
        { name: 'Oranges', icon: orangesImg, activeIcon: orangesImgW },
        { name: 'Onions', icon: onionsImg, activeIcon: onionsImgW },
        { name: 'Pears', icon: pearsImg, activeIcon: pearsImgW },
        { name: 'Potatoes', icon: potatoesImg, activeIcon: potatoesImgW },
        { name: 'Dried beans', icon: driedBeansImg, activeIcon: driedBeansImgW },
        { name: 'Rice', icon: riceImg, activeIcon: riceImgW },
        { name: 'Rye', icon: ryeImg, activeIcon: ryeImgW },
        { name: 'Bovine liver', icon: bovineLiverImg, activeIcon: bovineLiverImgW },
        { name: 'Poultry fat', icon: poultryFatImg, activeIcon: poultryFatImgW },
    ];
    const { id } = useParams();

    const handleCustonScrolling = () => {
        if (container.current) {
            const currentX = container.current.scrollWidth;
            container.current.scrollTo(container.current.scrollLeft + 60, 0);
        }
    }


    return (
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'column', md: 'row' } }} className="commoditiesMenuWrapper">
            <Box sx={{ display: 'flex', justifyContent: 'center', width: { md: '170px' } }}>
                <p style={{ display: 'flex', alignItems: 'center' }}>SELECT A FOOD COMMODITY TO VIEW DETAILED RESULTS</p>
                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} className="divider"></Box>
            </Box>
            <Box className="commodityChips" sx={{ display: 'flex' }}>
                <ScrollContainer className="scroll-container" innerRef={container}>
                    {commodities.map(c => {
                        const normalized = c.name.replace(' ', '-').toLowerCase();
                        return (
                            <ListItem key={normalized}>
                                <Link to={PageRoutes.COMMODITY_ROOT + normalized}>
                                    {/* /static/images/avatar/1.jpg */}
                                    <Chip
                                        avatar={<Avatar sx={{ background: 'none !important' }} alt="Natacha" src={id && id === normalized ? c.activeIcon : c.icon} />}
                                        color="primary"
                                        clickable
                                        style={{ padding: '2px 16px', margin: 0, color: id && id === normalized ? 'white' : '#246898', borderColor: '#246898' }}
                                        variant={id && id === normalized ? 'filled' : 'outlined'}
                                        label={c.name} />
                                </Link>
                            </ListItem>
                        );
                    })}
                </ScrollContainer>
                <IconButton color="primary" aria-label="upload picture" component="span" onClick={handleCustonScrolling}>
                    <ArrowForwardIcon />
                </IconButton>
            </Box>
        </Box>
    );
}

export default CommoditiesMenu;